// extracted by mini-css-extract-plugin
export var button = "_az-0";
export var icon = "_az-1";